import { Venue } from 'src/common/common.interface'
import { getHttp } from './apiLayer'
import { handleGetAllData } from './helper'

export interface PaginationParams {
  page?: number
  limit?: number
  isAll?: string
}

export interface IListVenuesParams extends PaginationParams {
  q?: string
}

export interface IListVenuesResponse {
  count: number
  result: Venue[]
}

export const getListVenues = async (queryParam: IListVenuesParams): Promise<IListVenuesResponse> => {
  const result = await getHttp(`venues/list`, { params: queryParam })
  return result.data
}

export const getAllVenues = async () => {
  const resultData = await handleGetAllData<Venue>('venues/list', 100)

  return resultData as Venue[]
}
